import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getMasterbroker(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getadmins",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getUsers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/getusers",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function getPaymentlist(payload) {
    const result = await axios.post(apiUrl + "/payment/search",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}
async function updatePayment(payload) {
    const result = await axios.post(apiUrl + "/payment/update",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function deletePayment(payload) {
    const result = await axios.post(apiUrl + "/payment/delete",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const CashLedgerService = {
    getPaymentlist,
    getMasterbroker,
    getUsers,
    updatePayment,
    deletePayment
}